import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import AvatarSmall from "../../common/AvatarSmall";
import User from './user';
import { replaceSpaceInName } from '../../../common/helperMethods';

export default (notification, index) => (
    <List.Item key={index}>
        <AvatarSmall id={notification.actor_id} name={notification.actor_name}/>
        <List.Content>
            <List.Description>
            <User id={notification.actor_id}/>{" "}
                has added{" "}
                <Link to={`/company/${replaceSpaceInName(notification.company_name)}/${notification.company_id}`}>
                    {notification.company_name}
                </Link>{" "}
                as a supplier of{" "}
                <Link to={`/product/${replaceSpaceInName(notification.linked_product_name)}/${notification.linked_product_id}`}>{notification.linked_product_name}</Link>{" "}
                raw material of{" "}
                <Link to={`/product/${replaceSpaceInName(notification.product_name)}/${notification.product_id}`}>{notification.product_name}</Link>
            </List.Description>
        </List.Content>
    </List.Item>);
